module.exports = __webpack_public_path__ + "static/textinput-label-dont-3e5d2eb11e9f3c4aa39669a20578de62.png";